"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import FormSection from "../ui/FormSection";
import { TraitWrapper } from "../../traits/TraitWrapper";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import type { AllowlistBatchRaw } from "../types/OperationalData";
export type { AllowlistBatchRaw } from "../types/OperationalData";
interface AllowlistBatchManagerProps {
  readonly batches: AllowlistBatchRaw[];
  readonly onBatchesChange: (batches: AllowlistBatchRaw[]) => void;
  readonly errors?: {
    contract?: string;
    token_ids?: string;
  }[];
}
const AllowlistBatchManager: React.FC<AllowlistBatchManagerProps> = t0 => {
  const $ = _c(22);
  const {
    batches,
    onBatchesChange,
    errors
  } = t0;
  let t1;
  if ($[0] !== batches || $[1] !== onBatchesChange) {
    t1 = () => {
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      onBatchesChange([...batches, {
        id,
        contract: "",
        token_ids_raw: ""
      }]);
    };
    $[0] = batches;
    $[1] = onBatchesChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleAddBatch = t1;
  let t2;
  if ($[3] !== batches || $[4] !== onBatchesChange) {
    t2 = index => {
      const newBatches = [...batches];
      newBatches.splice(index, 1);
      onBatchesChange(newBatches);
    };
    $[3] = batches;
    $[4] = onBatchesChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleRemoveBatch = t2;
  let t3;
  if ($[6] !== batches || $[7] !== onBatchesChange) {
    t3 = (index_0, field, value) => {
      const newBatches_0 = [...batches];
      const currentBatch = newBatches_0[index_0];
      if (!currentBatch) {
        return;
      }
      newBatches_0[index_0] = {
        ...currentBatch,
        [field]: value
      };
      onBatchesChange(newBatches_0);
    };
    $[6] = batches;
    $[7] = onBatchesChange;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleBatchChange = t3;
  let t4;
  if ($[9] !== batches || $[10] !== errors || $[11] !== handleBatchChange || $[12] !== handleRemoveBatch) {
    t4 = batches.length === 0 ? <div className="tw-py-2 tw-text-sm tw-italic tw-text-iron-500">No allowlist batches added.</div> : batches.map((batch, index_1) => <div key={batch.id} className="tw-flex tw-items-start tw-gap-x-3"><TraitWrapper label="Contract Address *" id={`batch-${index_1}-contract`} error={errors?.[index_1]?.contract} isFieldFilled={!!batch.contract && !errors?.[index_1]?.contract} className="tw-flex-1 tw-pb-0"><input type="text" placeholder="0x..." value={batch.contract} onChange={e => handleBatchChange(index_1, "contract", e.target.value)} className={`tw-form-input tw-w-full tw-truncate tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-py-3 tw-pl-4 tw-pr-11 tw-text-sm tw-text-iron-100 tw-outline-none tw-ring-1 ${errors?.[index_1]?.contract ? "tw-ring-red" : "tw-ring-iron-700"} focus:tw-ring-primary-400`} /></TraitWrapper><TraitWrapper label="Token IDs (e.g. 1,2,5-10)" id={`batch-${index_1}-token-ids`} error={errors?.[index_1]?.token_ids} isFieldFilled={!!batch.token_ids_raw && !errors?.[index_1]?.token_ids} className="tw-flex-1 tw-pb-0"><input type="text" placeholder="Optional" value={batch.token_ids_raw} onChange={e_0 => handleBatchChange(index_1, "token_ids_raw", e_0.target.value)} className={`tw-truncat tw-form-input tw-w-full tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-py-3 tw-pl-4 tw-pr-11 tw-text-sm tw-text-iron-100 tw-outline-none tw-ring-1 ${errors?.[index_1]?.token_ids ? "tw-ring-red" : "tw-ring-iron-700"} focus:tw-ring-primary-400`} /></TraitWrapper><button type="button" onClick={() => handleRemoveBatch(index_1)} className="tw-mt-2 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-2 tw-text-iron-400 tw-transition-colors tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-rose-400" aria-label={`Remove Batch ${index_1 + 1}`}><TrashIcon className="tw-size-5 tw-flex-shrink-0" /></button></div>);
    $[9] = batches;
    $[10] = errors;
    $[11] = handleBatchChange;
    $[12] = handleRemoveBatch;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t4}</div>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PlusIcon className="tw-size-4 tw-flex-shrink-0" />;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== handleAddBatch) {
    t7 = <button type="button" onClick={handleAddBatch} className="tw-mt-4 tw-flex tw-cursor-pointer tw-items-center tw-gap-x-1.5 tw-border-0 tw-bg-transparent tw-text-sm tw-font-semibold tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300">{t6}Add Batch</button>;
    $[17] = handleAddBatch;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <FormSection title="Allowlist Configuration">{t5}{t7}</FormSection>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default React.memo(AllowlistBatchManager);